import { render, staticRenderFns } from "./PrExpand.vue?vue&type=template&id=6ff976e8&"
import script from "./PrExpand.vue?vue&type=script&lang=js&"
export * from "./PrExpand.vue?vue&type=script&lang=js&"
import style0 from "./PrExpand.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports